import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import AthleteLayout from "../common/AthleteLayout";
import { AthleteHeader } from "../common/AthleteHeader";
import { useAthleteAuthContext } from "../login/useAthleteAuthContext";
import API_URL from "../../api/API";
import strengthimage from "../../images/strength1.png";

export const AthleteStaticStrengthWorkoutList = () => {
  const navigate = useNavigate();
  const { athlete } = useAthleteAuthContext();
  const { day_id } = useParams();

  const [selectedDate, setSelectedDate] = useState(new Date());
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [strengthData, setStrengthData] = useState([]);


  useEffect(() => {
    const fetchWorkoutData = async () => {
      try {
        setLoading(true);
        const response = await fetch(API_URL.GET_ATHLETE_STATIC_STRENGTH_WORKOUT_LIST_BY_DAY + day_id, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${athlete.token}`,
            'Content-Type': 'application/json'
          }
        });
        if (!response.ok) {
          throw new Error("Failed to fetch workout data");
        }
        const data = await response.json();
        console.log(data);
        setStrengthData(data.workouts);
      } catch (error) {
        console.error("Error fetching workout data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchWorkoutData();
  }, [athlete.token, day_id]);

 

  const changeDate = (days) => {
    setSelectedDate((prevDate) => {
      const newDate = new Date(prevDate);
      newDate.setDate(newDate.getDate() + days);
      return newDate;
    });
  };

  const formatDate = (date) => {
    return date.toLocaleDateString("en-US", {
      weekday: "long",
      month: "short",
      day: "numeric",
    });
  };

  const handleWorkoutClick = (id,type) => {
    console.log("Workout clicked with ID:", id);
    navigate('/athlete/static-strength-workout/workout-exercise/' + id + '/' + type);
  };
  
    // Handle back button click and pass templates state back
    const handleBackClick = () => {
      navigate(-1); // Pass templates back on go back
    };

return (
<AthleteLayout>
      <div className="bg-white">
        <AthleteHeader />
      </div>
      <div className="pb-3 flex flex-row justify-center items-center gap-10 bg-white">
        <ArrowL onClick={() => changeDate(-1)} />
        <p className="text-black text-xl font-normal">{formatDate(selectedDate)}</p>
        <ArrowG onClick={() => changeDate(1)} />
      </div>

      <div className="bg-white h-full">


        <div className="w-full max-w-2xl mx-auto pt-1 px-5">



         <div className="w-full text-center relative py-4">
            <span
              className="absolute left-5 top-1/2 -translate-y-1/2 flex items-center gap-2 cursor-pointer text-black hover:text-gray-500"
              onClick={handleBackClick}
            >
              <BackArrow /> Back
            </span>
          </div>

          {loading ? (
            <p className="text-black text-center">Loading Workouts...</p>
          ) : error ? (
            <div className="bg-red-100 text-red-500 p-3 rounded mb-4">{error}</div>
          ) : (
            <div className="bg-white h-full">
              <div className="w-full max-w-2xl mx-auto pt-1 px-5">
                {strengthData.length === 0 ? (
                  <p className="text-black text-center">No workouts found for this day.</p>
                ) : (
                  strengthData.map((item) => (
                    <div
                        key={item._id}
                        className="flex flex-row justify-between items-center gap-5 py-[15px] border-b border-black/10 cursor-pointer"
                        onClick={() => handleWorkoutClick(item._id,item.type)}  // Pass the specific _id to the function
                     >
                      <div className="flex flex-col gap-[6px] w-[80%]">
                        <p className="text-black text-base font-normal leading-none">
                          {item.title}
                        </p>
                        {/* Check if it's a superset or circuit and display all exercise titles */}
                        {item.type === "superset" || item.type === "circuit" ? (
                          <div>
                            {item.exercises.map((exercise, index) => (
                              <p key={index} className="text-black text-sm">
                                {exercise.title}
                              </p>
                            ))}
                          </div>
                        ) : (
                          <p></p>
                        )}
                        {item.notes && (
                          <p className="text-black text-base font-light leading-none">
                            {item.notes}
                          </p>
                        )}
                        {item.rest_details && (
                          <p className="text-black text-base font-light leading-none">
                            {item.rest_details}
                          </p>
                        )}
                      </div>
                      <div className="w-[38px] h-[38px] rounded-[5px] overflow-hidden">
                        <img
                            src={item.video_thumbnail || strengthimage}  // Use video_thumbnail if it exists, otherwise default to strength1
                            alt={item.title}
                            className="object-contain"
                        />
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </AthleteLayout>
  );
};


const BackArrow = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="w-5 h-5"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        stroke="black"
        d="M15 19l-7-7 7-7"
      />
    </svg>
  );
};

const ArrowG = ({ onClick }) => (
  <svg
    onClick={onClick}
    className="hover:opacity-50 cursor-pointer"
    xmlns="http://www.w3.org/2000/svg"
    width="8"
    height="14"
    viewBox="0 0 8 14"
    fill="none"
  >
    <path d="M1 13L7 7L1 1" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const ArrowL = ({ onClick }) => (
  <svg
    onClick={onClick}
    className="hover:opacity-50 rotate-180 cursor-pointer"
    xmlns="http://www.w3.org/2000/svg"
    width="8"
    height="14"
    viewBox="0 0 8 14"
    fill="none"
  >
    <path d="M1 13L7 7L1 1" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
